import { useStorageListBadgeTemplates } from '../../../../ui/features/badge-management/hooks/useStorageListBadgeTemplates';
import { Box, CircularProgress, Grid } from '@mui/material';
import React from 'react';
import { sortBadgeTemplatesByOrder } from '../utils/sortBadgeTemplatesByOrder';
import { BadgeTemplateSelectOption } from './BadgeTemplateSelectOption';
export const BadgeTemplatesSelect = ({ badgeTemplateSelected, onSelectBadgeTemplate }) => {
    const { data: badgeTemplates, isLoading } = useStorageListBadgeTemplates();
    const handleBadgeTemplateSelectionChanged = (badgeTemplateData) => {
        onSelectBadgeTemplate(badgeTemplateData);
    };
    if (isLoading)
        return (React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 2,
            } },
            React.createElement(CircularProgress, null)));
    return (React.createElement(Grid, { container: true, spacing: 2 }, badgeTemplates === null || badgeTemplates === void 0 ? void 0 : badgeTemplates.rows.sort(sortBadgeTemplatesByOrder).map((template) => (React.createElement(Grid, { key: template.id, size: {
            xs: 6,
            lg: 3,
        } },
        React.createElement(BadgeTemplateSelectOption, { key: template.id, badgeTemplate: template, selected: template.id === (badgeTemplateSelected === null || badgeTemplateSelected === void 0 ? void 0 : badgeTemplateSelected.id), onSelect: handleBadgeTemplateSelectionChanged }))))));
};
